import { Keypair} from '@stellar/stellar-sdk';
import { Buffer } from 'buffer';
import * as Sentry from '@sentry/react';
import { StellarToml } from '@stellar/stellar-sdk';

export class DisbursementUri {

    protected uri: URL;

    constructor(uri: URL | string) {
        this.uri = typeof uri === 'string' ? new URL(uri) : new URL(uri.toString());
    }

    get asset() {
        return this.getParam('asset');
    }

    get domain() {
        return this.getParam('domain');
    }

    get name() {
        return this.getParam('name');
    }

    get signature() {
        return this.getParam('signature');
    }

    protected getParam(key: string): string | undefined {
        return this.uri.searchParams.get(key) || undefined;
    }

    protected setParam(key: string, value?: string) {
        if (value === undefined) {
            this.uri.searchParams.delete(key);
        } else {
            this.uri.searchParams.set(key, value);
        }
    }

    public async verifySignature(): Promise<boolean> {

        const domain = this.domain;
        const signature = this.signature;
        console.log("Verifying signature for domain:", domain, "signature:", signature);

        if (!domain && !signature) {
            // if there's no origin domain or signature then there's nothing to verify
            console.log("No domain or signature to verify");
            return true;
        }

        if (!domain || !signature) {
            // we can fail fast if neither of them are set since we can't verify without both
            console.log("Either domain or signature is missing");
            return false;
        }

        try {

            const toml = await StellarToml.Resolver.resolve(domain);
            const signingKey = toml.SIGNING_KEY;

            if (!signingKey) {
                return false;
            }

            if (!this.uri) {
                return false;
            }
            const keypair = Keypair.fromPublicKey(signingKey);

            const response = this.extractSignatureAndUrl(this.uri);
            const urlBuffer = Buffer.from(response.urlWithoutSignature, "utf8");
            const signatureBuffer = Buffer.from(response.signature as string, "hex");

            return keypair.verify(urlBuffer, signatureBuffer);


        } catch (e) {

            Sentry.captureException(e)

            return false;
        }
    }

    protected extractSignatureAndUrl(url: URL): { urlWithoutSignature: string, signature: string | null } {

        const params = url.searchParams;

        const signature = params.get('signature');

        params.delete('signature');

        // Rebuild the URL without the 'signature' parameter
        const urlWithoutSignature = `${url.origin}${url.pathname}?${params}`;

        return { urlWithoutSignature, signature };
    }

}